"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, PropSync, Vue, Watch } from "vue-property-decorator";
import { DataSetModel } from "@/models/dataset.model";
let ExtShops = class extends Vue {
  constructor() {
    super(...arguments);
    // @PropSync("listshow",{type:Boolean,default:function () {
    //         return true
    //     }})
    // public _listshow?:boolean
    this.current_page = 1;
    this.shop_datas = [];
  }
  mounted() {
    this.reload();
  }
  reload() {
    this.shop_datas = [];
    let datas = this._shops;
    if (this._shops.length > 5) {
      for (let index = 0; index < this._shops.length; index += 5) {
        let item = datas.slice(index, index + 5);
        this.shop_datas.push(item);
      }
      console.log(this.shop_datas);
    } else {
      this.shop_datas = datas;
    }
  }
  bindShop() {
    this.$emit("bindshop");
  }
  previous() {
  }
  next() {
  }
};
__decorateClass([
  PropSync("shops", {
    type: DataSetModel,
    default: function() {
      return new Array();
    }
  })
], ExtShops.prototype, "_shops", 2);
__decorateClass([
  PropSync("canCreate", {
    type: Boolean,
    default: function() {
      return false;
    }
  })
], ExtShops.prototype, "_canCreate", 2);
__decorateClass([
  Watch("shops")
], ExtShops.prototype, "reload", 1);
ExtShops = __decorateClass([
  Component
], ExtShops);
export {
  ExtShops as default
};
